module.exports = "<p>ביצוע שיחות יוצאות בלבד ללקוחות.<br>שכר בסיס + עמלות, תנאים סוציאליים.<br>שעות נוחות, אפשרות למשרה מלאה.<br> סביבת עבודה צעירה ודינמית.</p> <p> <strong>דרישות:</strong></p> <ul> <li><p>ניסיון בטלמרקטינג - יתרון</p> </li> <li><p>ידע בשפה הרוסית - יתרון</p> </li> <li><p>כושר שכנוע ואסרטיביות</p> </li> <li><p>תודעת שירות גבוהה</p> </li> <li><p>ידע בסיסי בסביבת מחשב - חובה</p> </li> </ul> <p><strong>קורות חיים נא לשלוח ל- <a href=mailto:info@onmap.co.il>info@onmap.co.il</a></strong></p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/vacancies/en/telemarketing.md
// module id = 837
// module chunks = 0